import { RATERS } from '@/constants';

type RatingCopy = {
  title: string;
  body: string;
  ctaUrl: string;
};

export const RATING_COPY: Record<(typeof RATERS)[keyof typeof RATERS], RatingCopy> = {
  [RATERS.NO_RATING]: {
    title: 'This car has no rating',
    body: 'This car has not been rated – check to see if it has the maximum recommended safety features or look for a vehicle with a safety rating to be sure of it’s level of safety.',
    ctaUrl: '/ratings',
  },
  [RATERS.NO_CURRENT_RATING]: {
    title: 'This car has no current rating',
    body: 'This car does not have a current ANCAP safety rating, and has not received a Used Car Safety Rating.',
    ctaUrl: '/ratings',
  },
};
